import axios from "axios";

import { Toastr } from "clearsense-ui/components";

import { showToastrError } from "./common";

const rddAxios = axios.create({
  baseURL: process.env.RDD_API_URL,
});

rddAxios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      response.success = true;
    }

    if (response?.data?.ckd_risk) {
      Toastr.success("Prediction successful.");
    }

    return response;
  },

  async error => {
    showToastrError("Error in prediction endpoint.");

    return Promise.reject(error && error.response);
  }
);

export default rddAxios;
